import { createSlice } from "@reduxjs/toolkit";
import { userSignUp, userLogIn, userLogOut } from "./auth-actions";
import { retrieveStoredTokens } from "../../utils/auth-helper";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    loading: "unexecuted",
    token: "",
    firstName: "",
    lastName: "",
    expiresAt: null,
    userLoggedIn: false,
    error: "",
  },
  reducers: {
    RetreiveAuth(state) {
      const lsData = retrieveStoredTokens();
      if (lsData !== null) {
        state.firstName = lsData.firstName;
        state.lastName = lsData.lastName;
        state.token = lsData.token;
        state.expiresAt = lsData.expiresAt;
        state.userLoggedIn = true;
      } else {
        state.userLoggedIn = false;
      }
    },
  },

  extraReducers: {
    [userSignUp.pending]: (state) => {
      state.loading = "pending";
    },
    [userSignUp.fulfilled]: (state, action) => {
      state.loading = "completed";
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.token = action.payload.token;
      state.expiresAt = action.payload.expiresAt;
      state.error = "";
      state.userLoggedIn = true;
    },
    [userSignUp.rejected]: (state, action) => {
      state.loading = "completed";
      state.error = action.payload;
      state.userLoggedIn = false;
      state.expiresAt = null;
    },
    [userLogIn.pending]: (state) => {
      state.loading = "pending";
    },
    [userLogIn.fulfilled]: (state, action) => {
      state.loading = "completed";
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.token = action.payload.token;
      state.expiresAt = action.payload.expiresAt;
      state.error = "";
      state.userLoggedIn = true;
    },
    [userLogIn.rejected]: (state, action) => {
      state.loading = "completed";
      state.error = action.payload;
      state.userLoggedIn = false;
      state.expiresAt = null;
    },
    [userLogOut.fulfilled]: (state) => {
      state.loading = "completed";
      state.firstName = "";
      state.lastName = "";
      state.token = "";
      state.expiresAt = null;
      state.error = "";
      state.userLoggedIn = false;
    },
  },
});

export const authActions = authSlice.actions;
export default authSlice;
